import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../constants';
import { resetBuyCarsList } from '../redux/actions/carListAction';
import { getCarData } from '../redux/actions/carListingAction';
import { ICombineReducerType } from '../redux/reducers';
import CarCard from './CarCard';
import { NextChevron } from './icons/common.icons';
import SecSeperator from './ui/SecSeperator';

const TradeSecSection = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { buyCars, buyIsLoading } = useSelector(
        (state: ICombineReducerType) => state.carListReducer
    );

    useEffect(() => {
        resetBuyCarsList(dispatch);
        getCarData(dispatch, {
            voetstoots: true,
            limit: 2
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const goToTradeListings = () => {
        navigate(ROUTES.voetstootsTradeSale);
    };

    const goToTermsOfUse = () => {
        navigate(ROUTES.termsOfUse);
    };

    console.log('buyCars', buyCars);
    if (!buyCars.length && !buyIsLoading) return null;

    return (
        <div className="trade-sec-section-container">
            <div className="trade-sec-section ">
                <div className="trade-sec-content padding">
                    {/* Left Side - Blue Section */}
                    <div className="trade-sec-left">
                        <SecSeperator
                            bordercolor="white"
                            borderColor="black"
                        />
                        <h1 className="trade-sec-title">
                            {t('voetstootsTradeSaleTitle')}
                        </h1>
                        <p className="trade-sec-subtitle">
                            {t('voetstootsTradeSaleSubtitle')}
                        </p>

                        <ul className="trade-sec-list">
                            <li>
                                <span className="list-number">1</span>
                                {t('voetstootsTradeSaleList1')}
                            </li>
                            <li>
                                <span className="list-number">2</span>
                                {t('voetstootsTradeSaleList2')}
                            </li>
                            <li>
                                <span className="list-number">3</span>
                                {t('voetstootsTradeSaleList3')}
                            </li>
                            <li>
                                <span className="list-number">4</span>
                                {t('voetstootsTradeSaleList4')}
                            </li>
                            <li>
                                <span className="list-number">5</span>
                                {t('voetstootsTradeSaleList5')}
                            </li>
                            <li>
                                <span className="list-number">6</span>
                                {t('voetstootsTradeSaleList6')}
                            </li>
                        </ul>

                        <button
                            className="trade-sec-learn-more"
                            onClick={goToTermsOfUse}
                        >
                            {t('voetstootsTradeSaleLearnMore')}
                            <NextChevron />
                        </button>
                    </div>

                    {/* Right Side - White Section */}
                    <div className="trade-sec-right">
                        <div className="trade-sec-header">
                            <SecSeperator />
                            <div className="trade-sec-header-content">
                                <div className="trade-sec-header-text">
                                    <h2 className="trade-sec-right-title">
                                        {t('voetstootsTradeSaleTitleRight')}
                                    </h2>
                                    <p className="trade-sec-right-subtitle">
                                        {t('voetstootsTradeSaleCarsSubtitle')}
                                    </p>
                                </div>
                                <button
                                    className="view-all-link"
                                    onClick={goToTradeListings}
                                >
                                    {t('voetstootsTradeSaleViewAll')}{' '}
                                    <NextChevron />
                                </button>
                            </div>
                            <div
                                className={`trade-sec-cars ${
                                    buyIsLoading ? 'loading' : ''
                                } ${
                                    !buyCars?.length && !buyIsLoading
                                        ? 'empty'
                                        : ''
                                }`}
                            >
                                {buyIsLoading ? (
                                    <div>Loading cars...</div>
                                ) : buyCars?.length > 0 ? (
                                    buyCars.map((car) => (
                                        <CarCard key={car._id} data={car} />
                                    ))
                                ) : (
                                    <div>No voetstoots cars available</div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TradeSecSection;
